import { Player } from '../player/types';

export interface GameState {
	initPlayerTableOrder: number[];
	currentTurnTypePlayerTableOrder: number[];
	turnOrder: number[];
	numPlayers: number;
	activePlayerId: number;
	monthTracker: number;
	seasonTracker: number;
	carbonReservoir: number;

	turnType: string;

	singlePlayer: boolean;
	isTutorial: boolean;
	tutorialStep: number;

	game_id_server: number;
	gameStatus: number;

	summitCardDistribution: string;

	weightIndex: number;

	worldEnergy: {
		red: number;
		green: number;
		blue: number;
		yellow: number;
		carbon: number;
	};

	DeckSS: number[];
	DeckFW: number[];
	DeckNews: number[];
	DeckSummit: number[];

	discardPile: number[];

	seasonalNewsCards: number[];

	playerStateArray: Player[];

	triggers: any[];

	decisionPlayerId: number;
	decisionCardId: number;
	decisionChoiceArr: any[];
	decisionSourceArr: any[];
	decisionTargetArr: any[];

	isSummit: boolean;
	isSummitWinter: boolean;

	summitDraftPlayerIds: number[][];
	summitDraftCardIds: number[];
	summitDraftCardIdArrForDepth: number[][];
	summitDraftCardIdForPlayer: number[];

	// 2d array, each element is array of player ids who tied for highest donation
	// if all players are present, skip displaying this one
	summitWinners: number[][];
}

export const gameStateSimpleFields = [
	'numPlayers',
	'activePlayerId',
	'monthTracker',
	'seasonTracker',
	'carbonReservoir',
	'turnType',
	'singlePlayer',
	'isTutorial',
	'tutorialStep',
	'game_id_server',
	'gameStatus',
	'summitCardDistribution',
	'decisionPlayerId',
	'decisionCardId',
	'isSummit',
	'isSummitWinter',
	'weightIndex',
];

export const gameStateArrayFields = [
	'initPlayerTableOrder',
	'currentTurnTypePlayerTableOrder',
	'turnOrder',
	'DeckSS',
	'DeckFW',
	'DeckNews',
	'DeckSummit',
	'discardPile',
	'seasonalNewsCards',
	'summitDraftPlayerIds',
	'summitDraftCardIds',
	'summitDraftCardIdArrForDepth',
	'summitDraftCardIdForPlayer',
	'decisionChoiceArr',
	'decisionSourceArr',
	'decisionTargetArr',
	'triggers',
	'summitWinners',
];
